<div id="coordContainer">
  <p *ngIf="mapScale != null"id="scaleLine">
    Scale: <i id="scale">1:{{mapScale | number:'.0-0'}}</i>
  </p>
  <div id="coordinatesLine">
    Lat: <i id="latitude">{{latitude}}</i>&nbsp;&nbsp; Long: <i id="longitude">{{longitude}}</i>
  </div>
</div>
